import React from "react";
import { Card, Form, Input, Button, Space, Typography } from "antd";
import PhoneInput from "react-phone-input-2";

const { Title, Paragraph } = Typography;

export type IdentificacaoValues = {
  nome: string;
  sobrenome: string;
  celular: string;
  email: string;
};

type Props = {
  mode: "collect" | "confirm";
  loading?: boolean;
  initialData?: Partial<IdentificacaoValues> | null;
  onSubmit: (values: IdentificacaoValues) => Promise<void> | void;
};

export default function StepIdentificacao({
  loading = false,
  initialData,
  onSubmit,
}: Props) {
  const [form] = Form.useForm<IdentificacaoValues>();

  return (
    <Card>
      <Title level={4} style={{ marginBottom: 8 }}>
        Vamos começar sua solicitação de reserva
      </Title>
      <Paragraph style={{ marginBottom: 16 }}>
        Informe seus dados para continuarmos.
      </Paragraph>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
        initialValues={{
          nome: initialData?.nome ?? "",
          sobrenome: initialData?.sobrenome ?? "",
          celular: initialData?.celular ?? "",
          email: initialData?.email ?? "",
        }}
        disabled={loading}
      >
        <Form.Item name="nome" label="Nome" rules={[{ required: true, message: "Informe seu nome." }]}>
          <Input />
        </Form.Item>

        <Form.Item
          name="sobrenome"
          label="Sobrenome"
          rules={[{ required: true, message: "Informe seu sobrenome." }]}
        >
          <Input />
        </Form.Item>

      <Form.Item
            label="Celular (WhatsApp)"
            name="celular"
            rules={[
              { required: true, message: "Informe seu celular." },
              {
                validator: (_, v) => {
                  const digits = (v || "").replace(/\D/g, "");
                  // E.164: geralmente >= 10 dígitos. Pra BR com DDI+DDD+9 dígitos dá 13 (55 + 2 + 9)
                  if (digits.length >= 10) return Promise.resolve();
                  return Promise.reject(new Error("Informe um número válido."));
                },
              },
            ]}
          >
            <PhoneInput
              country={"br"}
              value={(form.getFieldValue("celular") || "").replace(/\D/g, "")} // sem '+'
              onChange={(value) => {
                // value = "5521991021054"
                form.setFieldValue("celular", `+${value.replace(/\D/g, "")}`);
              }}
              placeholder="Digite seu telefone"
              inputClass="phone-input"
              buttonClass="phone-input-button"
            />
        </Form.Item>

        <Form.Item
          name="email"
          label="E-mail"
          rules={[
            { required: true, message: "Informe seu e-mail." },
            { type: "email", message: "Informe um e-mail válido." },
          ]}
        >
          <Input />
        </Form.Item>

        <Space>
          <Button type="primary" htmlType="submit" loading={loading}>
            Continuar
          </Button>
        </Space>
      </Form>
    </Card>
  );
}
